export const getUserToken = () => localStorage.getItem('token') || '';

export const setUserToken = (token: string) =>
  localStorage.setItem('token', token);



// WEBPACK FOOTER //
// ./src/tools/token.ts